import React from "react";

const DEFAULT_CONTENT = (
  <>
    A website should <span className="bk-gold-text italic">drive action</span>, not just look good.
    These plans are built to give you <span className="bk-gold-text italic">clarity</span>,
    <span className="bk-gold-text italic"> momentum</span>, and measurable results —
    without overpaying or managing everything yourself.
  </>
);

export default function ValueBand({ content = DEFAULT_CONTENT }) {
  return (
    <section
      data-testid="value-band"
      className="relative py-14 border-y border-white/5"
      style={{
        background:
          "linear-gradient(90deg, transparent 0%, rgba(212,175,55,0.06) 50%, transparent 100%)",
      }}
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className="font-display text-2xl md:text-3xl lg:text-[2.4rem] leading-snug">
          {content}
        </p>
      </div>
    </section>
  );
}
